module.exports = __webpack_public_path__ + "static/media/apartment8.dbdef3b7.png";